<page-heading
  [title]="'department.list.pageTitle' | translate"
  [description]="'department.list.pageDescription' | translate"
/>

@if (isAdmin()) {
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-end">
            <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
              <button class="btn btn-success fw-bold" (click)="addDepartment()">{{ 'department.list.add' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (pager.total === 0) {
  <div class="card">
    <empty-records-component
      [message]="'department.list.emptyMessage' | translate"
      [subMessage]="'department.list.emptySubMessage' | translate"
      [labelButton]="'department.list.add' | translate"
      [icon]="'ri-team-line'"
      (emitEvent)="addDepartment()"
    />
  </div>
}

@if (pager.total > 0) {
  <div class="row g-3 mb-0">
    @for (item of pager.list; track $index) {
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <i class="ri-team-line"></i>

              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-dropdown-list"
                  [matMenuTriggerFor]="menu">
                  <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                </button>

                <mat-menu #menu="matMenu">
                  <button mat-menu-item tabindex="0" [routerLink]="['/user']">
                    {{ 'department.list.menuUsers' | translate }}
                  </button>
                  <button mat-menu-item tabindex="0" (click)="schedule(item)">
                    {{ 'department.list.menuSchedules' | translate }}
                  </button>
                  <button mat-menu-item tabindex="0" (click)="edit(item)">
                    {{ 'department.list.menuEdit' | translate }}
                  </button>
                  @if (isAdmin()) {
                    <button mat-menu-item tabindex="0" (click)="delete(item)">
                      {{ 'department.list.menuRemove' | translate }}
                    </button>
                  }
                </mat-menu>
              </div>
            </div>

            <h5 class="card-title mt-3">{{ item.name }}</h5>
            <p class="card-text text-muted">{{ getCountAttendants(item._id) }}</p>
          </div>
        </div>
      </div>
    }

    @if (pager.total > pager.perPage) {
      <paginator 
        [pager]="pager"
        (onPager)="loadPage($event)"
      />
    }
  </div>
}
